import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-hotel-single-sidebar',
    templateUrl: 'hotel-single-sidebar.component.html',
    styleUrls: ['../hotel-single.component.css', 'hotel-single-sidebar.component.css'],
    styles: [`
    .custom-day {
      text-align: center;
      padding: 0.285rem 0.35rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.disabled {
      background-color: #DFE8EB;
      color: #BCC4F3;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})

export class HotelSingleSidebarComponent implements OnInit {

    @Input() markers;

    @Input() mapCenter;

    @Input() hotels;

    @Input() extrasDates;
    @Input() roomsForBooking;
    @Input() hotelTypes;
    @Input() mealTypes;
    @Input() selectedRoomTypes;
    @Input() experiencesCategories;
    @Input() experiencesList;
    @Input() offerNote;
    @Input() selectedExperiences;
    @Output() bookNowClicked: EventEmitter<any> = new EventEmitter();
    @Output() bookedNowClickedZero = new EventEmitter();

    mapVisible = true;
    isClicked = false;
    hoveredDate: NgbDate;
    fromDate: NgbDate;
    toDate: NgbDate;
    selectedExtra: number;
    public showExtas = false;
    constructor(calendar: NgbCalendar) {this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 10); }


        ngOnInit() {

        }

    isMapVisible() {
        return this.mapVisible;
    }

    getColor() {
      if (this.extrasDates.size === 0) { return 'white'; }
      if (this.selectedExtra === undefined || this.selectedExtra === null) {
        this.selectedExtra = this.extrasDates.keys().next().value;
      }
      return  this.extrasDates.get(this.selectedExtra).color;
    }

    toggleMapVisibility() {
        this.mapVisible = !this.mapVisible;
    }

    getKeys(mapObj) {
        return Array.from(mapObj.keys());
    }

    onDateSelection(date: NgbDate) {
        if (!this.fromDate && !this.toDate) {
          this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
          this.toDate = date;
        } else {
          this.toDate = null;
          this.fromDate = date;
        }
      }

      isHovered(date: NgbDate) {
        const selectedDate = NgbDate.from(date);
        return false;
      }

      isDatesEqual(date1, date2) {
        return date1.year === date2.year && date1.month === date2.month && date1.day === date2.day;
      }

      isInside(date: NgbDate) {
        if (this.extrasDates.size === 0) { return false; }
        const xx = { day: date.day, month: date.month, year: date.year};
        const selectedDate: NgbDate = NgbDate.from(xx);

          if (this.selectedExtra === undefined || this.selectedExtra === null) {
              this.selectedExtra = this.extrasDates.keys().next().value;
        }


        let isInRange = false;

        this.extrasDates.get(this.selectedExtra).dates.forEach(dateToCheck => {
            const dateObj = new Date(dateToCheck);
            const ngbDateStruct = { day: dateObj.getDate(), month: dateObj.getMonth() + 1, year: dateObj.getFullYear()};
            const currentDate = NgbDate.from(ngbDateStruct);
            if (xx.day === ngbDateStruct.day && xx.month === ngbDateStruct.month && xx.year === ngbDateStruct.year) {
                isInRange = true;
            }
            if (this.isDatesEqual(selectedDate, currentDate)) {
                isInRange = true;
            }
        });

        return isInRange;

      }

      isRange(date: NgbDate) {
        return this.isInside(date);
      }

      changePeriod(key) {
        const date = new Date(this.extrasDates.get(key).dates[0]);
        const ngbDateStruct = { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear()};
        this.fromDate = NgbDate.from(ngbDateStruct);
        this.toDate = NgbDate.from(ngbDateStruct);

        this.selectedExtra = key;
      }

      markDisabledDays(date: NgbDate) {
        return false;
      }

      showMealTypes() { }

      bookNow() {
        if (!this.roomsForBooking || (this.roomsForBooking && this.roomsForBooking.size === 0)) {
         this.makeitTrue();
        } else {
          this.bookNowClicked.emit(true);
        }
      }



      getRoomTypes() {
        return Array.from(this.selectedRoomTypes.values());
      }

      getMinDate() {
        if (this.selectedExtra > 0) {
          const d = new Date(this.extrasDates.get(this.selectedExtra).dates[0]);
          const minDate = {year: d.getFullYear(), month: d.getMonth(), day: d.getDay()};
          return minDate;
        }
      }

      isExtrasVisible() {

        return this.showExtas;
      }

      toggleExtrasVisibility() {
        this.showExtas = !this.showExtas;
        const x = document.getElementById('extr');
        if (x.style.display === 'block') {
            x.style.display = 'none';
          } else {
            x.style.display = 'block';
          }
      }

      makeitTrue() {
        this.isClicked = true;
        this.bookedNowClickedZero.emit(this.isClicked);
        setTimeout(() => {
          this.isClicked = false;
          this.bookedNowClickedZero.emit(this.isClicked);
          }, 6000);
      }

}
